module.exports = __webpack_public_path__ + "img/shop.8376eeb7.png";